// LanguageToggle — minimal fr/ar/en switch. Calls `i18n.changeLanguage(lng)`
// → LanguageDetector persists to localStorage → the `languageChanged` handler
// (src/lib/i18n.ts) flips `documentElement.dir`/`lang`. No BE call (W8).
//
// F-FOUND ships this as the single reusable toggle; it is mounted ONLY on
// LoginScreen here (pre-auth pickability). F-SHELL mounts the 2nd instance on
// the real brand bar (it does NOT build its own). The persisted language is a
// device/UI preference exempt from the W5 store-reset sweep — it survives
// logout (a shared workstation keeps the chosen UI language).

import { useTranslation } from 'react-i18next'

const LANGS = ['fr', 'ar', 'en'] as const
type Lang = (typeof LANGS)[number]

export function LanguageToggle(): JSX.Element {
  const { t, i18n } = useTranslation()
  const active = i18n.language as Lang

  return (
    <div
      role="group"
      aria-label="Language"
      data-testid="language-toggle"
      style={{
        display: 'inline-flex',
        gap: 2,
        padding: 2,
        background: 'var(--bg-elevated)',
        borderRadius: 6,
      }}
    >
      {LANGS.map((lng) => {
        const isActive = active === lng
        return (
          <button
            key={lng}
            type="button"
            onClick={() => void i18n.changeLanguage(lng)}
            aria-pressed={isActive}
            data-testid={`language-toggle-${lng}`}
            style={{
              padding: '3px 8px',
              fontSize: 10.5,
              fontWeight: 700,
              letterSpacing: '0.04em',
              color: isActive ? '#fff' : 'var(--ink-60)',
              background: isActive ? 'var(--ink)' : 'transparent',
              border: 0,
              borderRadius: 4,
              cursor: 'pointer',
            }}
          >
            {t(`common.lang.${lng}`)}
          </button>
        )
      })}
    </div>
  )
}
